// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainProdvigate {

    display: flex;

    width: 100%;

    align-items: center;

    justify-content: center;

    padding: 77px 16px 100px 16px;

}



.myProdvigateContent {

    display: flex;

    flex-direction: column;

    width: 100%;

    background: #FFF4D9;

    border-radius: 16px;

    padding: 30px 0 0 0;

    position: relative;

    /*min-height: calc(100vh - 177px);*/

    width: 398px;

    height: 755px;

    gap: 9px;

}



.myProdvigateContentHeader {

    width: 100%;

    display: flex;

    flex-direction: row;

    align-items: center;

    justify-content: center;

    padding: 0 30px;

}



.myProdvigateContentHeaderTitle {

    font-family: Alegreya Sans;

    font-size: 32px;

    font-weight: 700;

    line-height: 25.6px;

    text-align: center;

    color: rgba(75, 45, 16, 1);

}

.myProdvigateBlocks {
    margin-top: 2px;
    padding-top: 2px;
}

.QR {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 15px;
}


.myProdvigates {
    display: flex;
    width: 100%;
    background: #FFE8AE;
    border-radius: 16px;
    /* padding: 5px 0; */
    /*min-height: calc(100vh - 177px);*/
    width: 169px;
    height: 344px;
}


.myProdvigates > div{
    border: 5px solid transparent; /* Default no border */
    cursor: pointer; /* Make it clear that the blocks are clickable */
}

.myProdvigates >div.selected{
    border: 5px solid #FFB800; /* Add blue border when selected */
}

.myProdvigatesExpress {
    display: flex;
    width: 100%;
    background: #FFE8AE;
    border-radius: 16px;
    /*min-height: calc(100vh - 177px);*/
    width: 362px;
    height: 279px;
    padding: 9px;
}

.Photos {
    padding: 4px;
}

.nameTarif {
    font-size: 18px;
}


.skida {
    position: absolute;
    margin-top: 115px;
    margin-bottom: 0px;
    margin-right: 0px;
    margin-left: -55px;
}

.tarifElements {
    padding: 2px;
    margin: auto 0px;
}

.myProdvigateContentButton {
    width: 362px; 
    height: 36px;
    gap: -13px;
    border-radius: 8px;
    background: #FF6B00;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin: auto auto;
    font-family: Alegreya Sans;
    font-size: 20px;
    font-weight: 500;
    line-height: 10px;
    text-align: center;
    color: #FFF4D9;

    /* Add styles for the button */
    background-color: #FA9F5E; /* Default grey */
    cursor: pointer;

}

.myProdvigateContentButton:disabled {
    background-color: #FA9F5E; /* Greyed out when disabled */
    cursor: not-allowed;
}


.linkNolineCreate {
    text-decoration: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Profile/Prodvigate/Prodvigate.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;;IAEb,WAAW;;IAEX,mBAAmB;;IAEnB,uBAAuB;;IAEvB,6BAA6B;;AAEjC;;;;AAIA;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,WAAW;;IAEX,mBAAmB;;IAEnB,mBAAmB;;IAEnB,mBAAmB;;IAEnB,kBAAkB;;IAElB,mCAAmC;;IAEnC,YAAY;;IAEZ,aAAa;;IAEb,QAAQ;;AAEZ;;;;AAIA;;IAEI,WAAW;;IAEX,aAAa;;IAEb,mBAAmB;;IAEnB,mBAAmB;;IAEnB,uBAAuB;;IAEvB,eAAe;;AAEnB;;;;AAIA;;IAEI,0BAA0B;;IAE1B,eAAe;;IAEf,gBAAgB;;IAEhB,mBAAmB;;IAEnB,kBAAkB;;IAElB,0BAA0B;;AAE9B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,mCAAmC;IACnC,YAAY;IACZ,aAAa;AACjB;;;AAGA;IACI,6BAA6B,EAAE,sBAAsB;IACrD,eAAe,EAAE,gDAAgD;AACrE;;AAEA;IACI,yBAAyB,EAAE,kCAAkC;AACjE;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,mCAAmC;IACnC,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;;IAEd,8BAA8B;IAC9B,yBAAyB,EAAE,iBAAiB;IAC5C,eAAe;;AAEnB;;AAEA;IACI,yBAAyB,EAAE,6BAA6B;IACxD,mBAAmB;AACvB;;;AAGA;IACI,gCAAgC;AACpC","sourcesContent":[".mainProdvigate {\n\n    display: flex;\n\n    width: 100%;\n\n    align-items: center;\n\n    justify-content: center;\n\n    padding: 77px 16px 100px 16px;\n\n}\n\n\n\n.myProdvigateContent {\n\n    display: flex;\n\n    flex-direction: column;\n\n    width: 100%;\n\n    background: #FFF4D9;\n\n    border-radius: 16px;\n\n    padding: 30px 0 0 0;\n\n    position: relative;\n\n    /*min-height: calc(100vh - 177px);*/\n\n    width: 398px;\n\n    height: 755px;\n\n    gap: 9px;\n\n}\n\n\n\n.myProdvigateContentHeader {\n\n    width: 100%;\n\n    display: flex;\n\n    flex-direction: row;\n\n    align-items: center;\n\n    justify-content: center;\n\n    padding: 0 30px;\n\n}\n\n\n\n.myProdvigateContentHeaderTitle {\n\n    font-family: Alegreya Sans;\n\n    font-size: 32px;\n\n    font-weight: 700;\n\n    line-height: 25.6px;\n\n    text-align: center;\n\n    color: rgba(75, 45, 16, 1);\n\n}\n\n.myProdvigateBlocks {\n    margin-top: 2px;\n    padding-top: 2px;\n}\n\n.QR {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    margin-bottom: 15px;\n}\n\n\n.myProdvigates {\n    display: flex;\n    width: 100%;\n    background: #FFE8AE;\n    border-radius: 16px;\n    /* padding: 5px 0; */\n    /*min-height: calc(100vh - 177px);*/\n    width: 169px;\n    height: 344px;\n}\n\n\n.myProdvigates > div{\n    border: 5px solid transparent; /* Default no border */\n    cursor: pointer; /* Make it clear that the blocks are clickable */\n}\n\n.myProdvigates >div.selected{\n    border: 5px solid #FFB800; /* Add blue border when selected */\n}\n\n.myProdvigatesExpress {\n    display: flex;\n    width: 100%;\n    background: #FFE8AE;\n    border-radius: 16px;\n    /*min-height: calc(100vh - 177px);*/\n    width: 362px;\n    height: 279px;\n    padding: 9px;\n}\n\n.Photos {\n    padding: 4px;\n}\n\n.nameTarif {\n    font-size: 18px;\n}\n\n\n.skida {\n    position: absolute;\n    margin-top: 115px;\n    margin-bottom: 0px;\n    margin-right: 0px;\n    margin-left: -55px;\n}\n\n.tarifElements {\n    padding: 2px;\n    margin: auto 0px;\n}\n\n.myProdvigateContentButton {\n    width: 362px; \n    height: 36px;\n    gap: -13px;\n    border-radius: 8px;\n    background: #FF6B00;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    margin: auto auto;\n    font-family: Alegreya Sans;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 10px;\n    text-align: center;\n    color: #FFF4D9;\n\n    /* Add styles for the button */\n    background-color: #FA9F5E; /* Default grey */\n    cursor: pointer;\n\n}\n\n.myProdvigateContentButton:disabled {\n    background-color: #FA9F5E; /* Greyed out when disabled */\n    cursor: not-allowed;\n}\n\n\n.linkNolineCreate {\n    text-decoration: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
